import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-200 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg comic-pop font-bold">
              韩漫
            </span>
            <div>
              <p className="font-heading text-lg text-foreground-950 leading-none">韩国免费漫画</p>
              <p className="text-[11px] text-foreground-500 mt-1 tracking-widest">KO-MANHWA NAV</p>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-md">
            韩国免费漫画资源聚合导航，一站式整理韩国免费漫画网站大全、韩漫APP合集与日更无遮拦在线看入口，帮助每位读者快速找到靠谱、稳定的追更渠道。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-md">
            网站仅提供资源入口与信息整理，不直接上传漫画内容，阅读请支持正版。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-950 mb-4">快速导航</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/ziyuan" className="hover:text-primary-500 transition-colors">漫画资源导航</Link></li>
            <li><Link to="/app" className="hover:text-primary-500 transition-colors">韩漫APP合集</Link></li>
            <li><Link to="/tuijian" className="hover:text-primary-500 transition-colors">新作与热门连载</Link></li>
            <li><Link to="/article" className="hover:text-primary-500 transition-colors">文章专题</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-950 mb-4">帮助中心</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/faq" className="hover:text-primary-500 transition-colors">常见问题</Link></li>
            <li><Link to="/about" className="hover:text-primary-500 transition-colors">关于我们</Link></li>
            <li><Link to="/contact" className="hover:text-primary-500 transition-colors">联系我们</Link></li>
          </ul>
          <p className="mt-5 text-sm text-foreground-600">
            商务合作 / 意见反馈<br />
            <span className="text-foreground-800">support@hanguofeifei.com</span>
          </p>
        </div>
      </div>

      <div className="border-t border-background-300/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-600">
          <p>© 2026 韩国免费漫画 · 韩漫资源聚合导航 · 保留所有权利</p>
          <p className="flex items-center gap-4">
            <span className="hover:text-foreground-800 transition-colors">版权声明</span>
            <span className="hover:text-foreground-800 transition-colors">免责声明</span>
            <span className="hover:text-foreground-800 transition-colors">隐私政策</span>
          </p>
        </div>
      </div>
    </footer>
  );
}